/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ubb.component.status.service.rpc.UbbComponentStatusServiceExternalRpc
 */
import * as References from './UbbComponentStatusServiceExternalRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ubb.component.status.service.rpc.UbbComponentStatusServiceExternalRpc#getComponentStatus
 */
export const GET_COMPONENT_STATUS_QUERY_FIELD_NAME = 'com_hubspot_ubb_component_status_service_rpc_UbbComponentStatusServiceExternalRpc_getComponentStatus';
export const GET_COMPONENT_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COMPONENT_STATUS_QUERY_FIELD_NAME,
  args: ['component'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getComponentStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});